import React from 'react';
import { Box, Typography, IconButton, Fade } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import CloseIcon from '@mui/icons-material/Close';

const ErrorMessage = ({ open, message, onClose }) => {
    return (
        <Fade in={open}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#e55934',
                    color: 'white',
                    padding: '8px',
                    borderRadius: '4px',
                    boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2)',
                    margin: '20px auto',
                    maxWidth: '100%',
                }}
            >
                <WarningIcon sx={{ marginRight: '8px' }} />
                <Typography variant='body1'>{message}</Typography>
                <IconButton
                    sx={{ marginLeft: 'auto' }}
                    color='inherit'
                    size='small'
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
        </Fade>
    );
};

export default ErrorMessage;
